import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  BULK_CREATE_BOOKING_CONFLICT_CSV_HEADERS,
  BULK_OPERATIONS_BOOKINGS_CSV_HEADERS,
  csvHeadersRides,
  removeMetadataPrefix,
} from "@ryde/shared";

export const useTranslatedLists = () => {
  const { t } = useTranslation();
  const bulkBookingsCSVHeadersTranslated = useMemo(
    () =>
      BULK_OPERATIONS_BOOKINGS_CSV_HEADERS.map(headerDropdownItem => {
        return {
          ...headerDropdownItem,
          label: t(
            `booking.formLabel.${removeMetadataPrefix(headerDropdownItem.key)}`,
          ).replace(":", ""),
        };
      }),
    [t],
  );

  const ridesCSVHeadersTranslated = useMemo(
    () =>
      csvHeadersRides.map(headerDropdownItem => {
        return {
          ...headerDropdownItem,
          label: t(
            `ride.formLabel.${removeMetadataPrefix(headerDropdownItem.key)}`,
          ).replace(":", ""),
        };
      }),
    [t],
  );

  const bookingConflictsCSVHeadersTranslated = useMemo(
    () =>
      BULK_CREATE_BOOKING_CONFLICT_CSV_HEADERS.map(headerDropdownItem => {
        return {
          ...headerDropdownItem,
          label: t(
            `booking.formLabel.conflictsDetails.${removeMetadataPrefix(headerDropdownItem.key)}`,
          ).replace(":", ""),
        };
      }),
    [t],
  );
  return {
    bulkBookingsCSVHeadersTranslated,
    ridesCSVHeadersTranslated,
    bookingConflictsCSVHeadersTranslated,
  };
};
